import gql from "graphql-tag";

export const GET_COUNCIL_STATISTIC = gql`
  query getCouncilOverview(
    $startDate: DateTime!
    $endDate: DateTime!
    $comparisonStartDate: DateTime!
    $comparisonEndDate: DateTime!
    $council_profile_id: String!
  ) {
    getCouncilDashboardOverviewStatistics(
      input: {
        startDate: $startDate
        endDate: $endDate
        comparisonStartDate: $comparisonStartDate
        comparisonEndDate: $comparisonEndDate
        council_profile_id: $council_profile_id
      }
    ) {
      totalTicketsIncome {
        percentageDiff
        value
      }
      totalEventCreated {
        percentageDiff
        value
      }
      totalTicketsSold {
        percentageDiff
        value
      }
    }
  }
`;

export const GET_TICKET_INCOME_LINE_CHART = gql`
  query getCouncilTotalIncomeLineChart(
    $startDate: DateTime!
    $endDate: DateTime!
    $council_profile_id: String!
  ) {
    getCouncilDashboardTotalTicketsIncomeLineChart(
      input: {
        startDate: $startDate
        endDate: $endDate
        council_profile_id: $council_profile_id
      }
    ) {
      x
      y
    }
  }
`;
